import {AnalysisGraphQL, AnalysisViewGraphQL} from 'analysis-tool/AnalysisTypes';
import {getOutputDataForView, isFileView} from 'analysis-tool/data-view/AnalysisViewUtils';
import {ButtonDataViewAction} from 'analysis-tool/data-view/DataViewContext';
import {checkCanModifyStep} from 'analysis-tool/EditStepHelpers';
import isAnalysisReadOnly from 'analysis-tool/isAnalysisReadOnly';
import {
  AnalysisRightSidebarItem,
  AnalysisRightSidebarItemType,
} from 'analysis-tool/right-sidebar/RightSidebarTypes';
import {AnalysisMainViewItem} from 'analysis-tool/ui/main-view/MainViewTypes';

export default function getEditViewAction(
  analysis: AnalysisGraphQL,
  view: AnalysisViewGraphQL,
  onChangeSelectedItem: (newSelectedItem: AnalysisMainViewItem) => void,
  onChangeSelectedRightSidebarItem: (newSelectedItem: AnalysisRightSidebarItem | null) => void
): ButtonDataViewAction | null {
  if (getOutputDataForView(view) == null || isFileView(view) || isAnalysisReadOnly(analysis)) {
    return null;
  }

  const firstNode = view.lineage[0];
  const lastNode = view.lineage[view.lineage.length - 1];

  const {canEdit, message} = checkCanModifyStep(analysis, firstNode.step.id, 'view', false);

  return {
    icon: 'edit',
    onClick: () => {
      onChangeSelectedRightSidebarItem({
        type: AnalysisRightSidebarItemType.EDIT_VIEW,
        stepId: lastNode.step.id,
      });
    },
    helpText: message ?? 'Edit view',
    isDisabled: !canEdit,
  };
}
